module.exports = __webpack_public_path__ + "img/btn_first_livecasino.545970e6.png";